import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=f2ca72f8&"
import script from "./dialog.vue?vue&type=script&lang=js&"
export * from "./dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports